import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { IIcon, IconSizesEnum } from 'i2g-ng-ui';

@Component({
  selector: 'app-social-button',
  templateUrl: 'social-button.component.html',
  styleUrls: ['./social-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SocialButtonComponent implements OnInit {
  @Input() e2eId: string;
  @Input() icon: IIcon;
  @Input() isLoading: boolean;
  @Input() disabled: boolean;

  @Output() buttonClick = new EventEmitter();

  spinnerIcon: IIcon;

  constructor() {}

  ngOnInit() {
    this.spinnerIcon = {
      name: 'dotted-spinner',
      size: IconSizesEnum.custom,
    };
  }
}
